module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("前台權限"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        _vm.createMedAppP = true
      }
    }
  }, [_vm._v(" + ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.createMedAppP) ? _c('div', {
    staticClass: "create-form"
  }, [_c('p', [_vm._v("新增前台權限樣板 "), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        _vm.createMedAppP = false
      }
    }
  }, [_vm._v(" X ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medAppName),
      expression: "medAppName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medAppName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medAppName = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.fields.medApp), function(field) {
    return (field.name !== 'name' && field.name !== '__slot:action') ? _c('div', {
      staticClass: "form-check form-check-inline"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedMedApp),
        expression: "checkedMedApp"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": field.name,
        "checked": Array.isArray(_vm.checkedMedApp) ? _vm._i(_vm.checkedMedApp, field.name) > -1 : (_vm.checkedMedApp)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedMedApp,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = field.name,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedMedApp = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedMedApp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedMedApp = $$c
          }
        }
      }
    }), _vm._v(_vm._s(field.title) + "\n        ")])]) : _vm._e()
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addMedAppP
    }
  }, [_vm._v("新增")])], 2) : _vm._e()]), _vm._v(" "), _c('vuetable', {
    ref: "vuetableMedApp",
    attrs: {
      "api-url": (_vm.server + "/api/med-app-privilege/"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields.medApp,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "detail-row-component": "user-group-settings-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger",
          on: {
            "click": function($event) {
              return _vm.deleteMedAppP(props.rowData.id)
            }
          }
        }, [_vm._v("刪除")])]
      }
    }])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("後台權限 "), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        _vm.createServerP = true
      }
    }
  }, [_vm._v(" + ")])]), _vm._v(" "), (_vm.createServerP) ? _c('div', {
    staticClass: "create-form"
  }, [_c('p', [_vm._v("新增後台權限樣板 "), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        _vm.createServerP = false
      }
    }
  }, [_vm._v(" X ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serverName),
      expression: "serverName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.serverName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serverName = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.fields.server), function(field) {
    return (field.name !== 'name' && field.name !== '__slot:action') ? _c('div', {
      staticClass: "form-check form-check-inline"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedServer),
        expression: "checkedServer"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": field.name,
        "checked": Array.isArray(_vm.checkedServer) ? _vm._i(_vm.checkedServer, field.name) > -1 : (_vm.checkedServer)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedServer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = field.name,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedServer = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedServer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedServer = $$c
          }
        }
      }
    }), _vm._v(_vm._s(field.title) + "\n      ")])]) : _vm._e()
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addServerP
    }
  }, [_vm._v("新增")])], 2) : _vm._e(), _vm._v(" "), _c('vuetable', {
    ref: "vuetableServer",
    attrs: {
      "api-url": (_vm.server + "/api/server-privilege/"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields.server,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger",
          on: {
            "click": function($event) {
              return _vm.deleteServerP(props.rowData.id)
            }
          }
        }, [_vm._v("刪除")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46818b18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/UserGroupSettings.vue
// module id = 1457
// module chunks = 1